import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { usePermissions } from '../hooks/usePermissions';
import { roleTranslations } from '../utils/translations';
import Logo from './Logo';
import CreateOrganizationModal from './CreateOrganizationModal';

const Navbar = () => {
    const { isAuthenticated, logout, user, organization, reloadUser } = useAuth();
    const navigate = useNavigate();
    const [isNavCollapsed, setIsNavCollapsed] = useState(true);
    const [showCreateOrganizationModal, setShowCreateOrganizationModal] = useState(false);

    const { canRead: canReadEventRoles } = usePermissions('eventRole');
    const { canRead: canReadUsers } = usePermissions('userManagement');
    const { canRead: canReadSongs } = usePermissions('song');
    const { canRead: canReadEvents } = usePermissions('event');

    const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);
    const closeNav = () => setIsNavCollapsed(true);

    const handleLogout = () => {
        logout();
        navigate('/login');
        closeNav();
    };

    const handleCreateOrganizationSuccess = async () => {
        await reloadUser();
        setShowCreateOrganizationModal(false);
    };

    const activeLinkStyle = {
        color: 'white',
        textDecoration: 'underline',
    };

    return (
        <>
            <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
                <div className="container-fluid">
                    <NavLink className="navbar-brand d-flex align-items-center" to="/" onClick={closeNav}>
                        <span className="ms-2"><Logo /></span>
                    </NavLink>
                    <button className="navbar-toggler" type="button" onClick={handleNavCollapse} aria-expanded={!isNavCollapsed} aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className={`collapse navbar-collapse ${!isNavCollapsed ? 'show' : ''}`} id="navbarNav">
                        <ul className="navbar-nav me-auto">
                            {isAuthenticated && user && user.organization_id && (
                                <>
                                    <li className="nav-item">
                                        <NavLink className="nav-link" style={({ isActive }) => isActive ? activeLinkStyle : undefined} to={`/organization/${user.organization_id}`} onClick={closeNav} end>{organization ? organization.name : 'Моя организация'}</NavLink>
                                    </li>
                                    {canReadEvents && (
                                        <li className="nav-item">
                                            <NavLink className="nav-link" style={({ isActive }) => isActive ? activeLinkStyle : undefined} to="/events" onClick={closeNav}>События</NavLink>
                                        </li>
                                    )}
                                    {canReadEventRoles && (
                                        <li className="nav-item">
                                            <NavLink className="nav-link" style={({ isActive }) => isActive ? activeLinkStyle : undefined} to="/event-roles" onClick={closeNav}>Роли</NavLink>
                                        </li>
                                    )}
                                    {canReadUsers && (
                                        <li className="nav-item">
                                            <NavLink className="nav-link" style={({ isActive }) => isActive ? activeLinkStyle : undefined} to={`/organization/${user.organization_id}/users`} onClick={closeNav}>Пользователи</NavLink>
                                        </li>
                                    )}
                                    {canReadSongs && (
                                        <li className="nav-item">
                                            <NavLink className="nav-link" style={({ isActive }) => isActive ? activeLinkStyle : undefined} to="/songs" onClick={closeNav}>Песни</NavLink>
                                        </li>
                                    )}
                                    <li className="nav-item">
                                        <NavLink className="nav-link" style={({ isActive }) => isActive ? activeLinkStyle : undefined} to="/public-libraries" onClick={closeNav}>Общие фонотеки</NavLink>
                                    </li>
                                </>
                            )}
                            {isAuthenticated && user && !user.organization_id && (
                                <li className="nav-item">
                                    <button className="nav-link" onClick={() => { setShowCreateOrganizationModal(true); closeNav(); }} style={{ background: 'none', border: 'none' }}>Создать организацию</button>
                                </li>
                            )}
                            {isAuthenticated && user && user.is_superuser && (
                                <li className="nav-item">
                                    <NavLink className="nav-link" style={({ isActive }) => isActive ? activeLinkStyle : undefined} to="/admin" onClick={closeNav}>Админ-панель</NavLink>
                                </li>
                            )}
                        </ul>
                        <ul className="navbar-nav">
                            {isAuthenticated && user ? (
                                <li className="nav-item d-flex align-items-center">
                                    <NavLink to="/profile" className="nav-link" style={({ isActive }) => isActive ? activeLinkStyle : undefined} onClick={closeNav}>
                                        {user.name || user.email}
                                    </NavLink>
                                    {user.role_in_organization && (
                                        <span className="navbar-text me-2">({roleTranslations[user.role_in_organization] || user.role_in_organization})</span>
                                    )}
                                    <button className="nav-link text-danger" onClick={handleLogout} style={{ background: 'none', border: 'none' }}>Выйти</button>
                                </li>
                            ) : (
                                <>
                                    <li className="nav-item">
                                        <NavLink className="nav-link" style={({ isActive }) => isActive ? activeLinkStyle : undefined} to="/login" onClick={closeNav}>Вход</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink className="nav-link" style={({ isActive }) => isActive ? activeLinkStyle : undefined} to="/register" onClick={closeNav}>Регистрация</NavLink>
                                    </li>
                                </>
                            )}
                        </ul>
                    </div>
                </div>
            </nav>
            <CreateOrganizationModal
                show={showCreateOrganizationModal}
                onHide={() => setShowCreateOrganizationModal(false)}
                onSuccess={handleCreateOrganizationSuccess}
            />
        </>
    );
};

export default Navbar;
